import { Injectable } from '@angular/core';
import { LinkTypeEnum } from '@portal-app/enums/link-type.enum';
import { IMegaMenu, IMegaMenuTab } from '@portal-app/interfaces/project/mega-menu.interface';
import { IUmbNavbar } from '@portal-app/interfaces/umbraco/umb-navbar.interface';
import { HtmlService } from '@portal-app/services/shared/html.service';

@Injectable({
  providedIn: 'root',
})
export class MegaMenuMapper {
  constructor(private htmlService: HtmlService) {}

  mapMegaMenuFromApi(navbar: IUmbNavbar): IMegaMenu {
    const result: IMegaMenu = {
      Tabs: [],
    };

    const css: string[] = [];

    navbar.rows.forEach((row, i) => {
      row.columns.forEach((column, j) => {
        if (column.value?.items) {
          column.value?.items.forEach((item, k) => {
            if (item.type === LinkTypeEnum.Dropdown) {
              const dropdown: IMegaMenuTab = {
                Title: item.name,
                Label: item.label,
                Items: [],
              };
              item.items.forEach((child, l) => {
                const className = `hover-${i}-${j}-${k}-${l}`;
                if (child.hoverColor) {
                  css.push(
                    `portal-mega-menu .${className}:hover { background-color: ${child.hoverColor} !important; }`
                  );
                }

                dropdown.Items.push({
                  Icon: child.iconUrl,
                  Title: child.name,
                  Label: child.label,
                  Url: child.url ? `${child.url}?portalclick=megamenu` : '',
                  Target: child.target ?? '_blank',
                  Description: this.htmlService.fixHtml(child.description),
                  Hover: child.hoverColor
                    ? {
                        ClassName: className,
                        Color: child.hoverColor,
                      }
                    : undefined,
                });
              });
              result.Tabs.push(dropdown);
            } else if (item.type === LinkTypeEnum.External) {
              result.Link = {
                Title: item.name,
                Url: item.url ? `${item.url}?portalclick=megamenu` : '',
              };
            }
          });
        }
      });
    });
    if (result) {
      if (css) {
        const style = document.createElement('style');
        style.appendChild(document.createTextNode(css.join('')));
        document.getElementsByTagName('head')[0].appendChild(style);
      }
      result.CurrentTab = result.Tabs[0];
    }
    return result;
  }
}
